import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import React, { CSSProperties, FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Container, LinkButton, ShortText, Text } from './ListButtons.style';

interface LinkType {
  text: string;
  shortText: string;
  url: string;
  icon: any;
  active?: boolean;
  shallow?: boolean;
}

interface Props {
  containerStyle?: CSSProperties;
  links: LinkType[];
}

const ListButtons: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <Container style={props.containerStyle}>
      {props.links.map((link) => (
        <Link href={link.url} passHref shallow={link.shallow} key={link.url} prefetch={false}>
          <LinkButton active={link.active}>
            <FontAwesomeIcon icon={link.icon} color={theme.textDark} style={{ fontSize: 22 }} />
            <Text>{link.text}</Text>
            <ShortText>{link.shortText}</ShortText>
          </LinkButton>
        </Link>
      ))}
    </Container>
  );
};

export default ListButtons;
